<div class="tooltip-container">
  <ng-content></ng-content>
  <!-- internal tooltip shown only if portal couldn't be created -->
  <div class="tooltip-content tooltip-markdown" *ngIf="show && showInternal" [ngStyle]="tooltipStyles">
    <ng-container *ngIf="useMarkdown; else plainText">
      <markdown [data]="content"></markdown>
    </ng-container>
    <ng-template #plainText>
      <markdown [data]="formattedContent"></markdown>
    </ng-template>
  </div>
</div>
